t = require('views/internal/teacup-with-helpers')('sticker_on_card')

module.exports = ->
  t.img '.sticker-image', { src: t.mustacheVar('url'), style: '-webkit-transform: rotate(' + t.mustacheVar('rotate') + 'deg);transform: rotate(' + t.mustacheVar('rotate') + 'deg);', alt: t.mustacheVar('image') }
  t.mustacheBlock 'showEditControls', ->
    t.div '.sticker-controls', ->
      t.span '.sticker-control-btn.rotate-btn.js-rotate-sticker', ->
        t.format 'rotate'
      t.span '.sticker-control-btn.move-btn.js-move-sticker', ->
        t.format 'move'
      t.span '.sticker-control-btn.remove-btn.js-remove-sticker', ->
        t.format 'remove'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/sticker_on_card.coffee